import RateRequestList from './RateRequest';
import useCompanyRateRequest from './useCompanyRateRequest';

import CompanyFinanceDetails from '../CompanyDetails/Company/CompanyFinanceDetails';

export interface CompanyRateRequestProps {}

const CompanyRateRequest: React.FunctionComponent<CompanyRateRequestProps> =
  function ({}) {
    const {
      fca,
      lenderConfigs,
      businessConfig,
      toAdd,
      toRemove,
      onClick,
      isSubmitting,
    } = useCompanyRateRequest();
    return (
      <div className="flex flex-row w-full gap-4">
        <div className="flex flex-col w-1/2">
          <RateRequestList
            toAdd={toAdd}
            toRemove={toRemove}
            isSubmitting={isSubmitting}
            onClick={onClick}
          />
        </div>
        <div className="flex flex-col w-1/2">
          <CompanyFinanceDetails
            fca={fca}
            lenderConfigs={lenderConfigs}
            businessConfig={businessConfig}
          />
        </div>
      </div>
    );
  };

export default CompanyRateRequest;
